import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "../ui/Toast";
import { useAuth } from "./AuthContext";
import { setLoginNext } from "../../utils/lastProduct";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { status, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const toastedRef = useRef(false);

  useEffect(() => {
    if (status === "unauthenticated") {
      // 401 등 인증 실패 — 서버가 내려준 메시지를 그대로 토스트로 노출 (1회)
      if (error && !toastedRef.current) {
        toastedRef.current = true;
        toast.show({ type: "error", message: error });
      }
      // 딥링크로 들어왔다가 튕긴 경우 — 로그인 후 원래 경로로 돌려보내기 위해 기록
      setLoginNext(location.pathname + location.search + location.hash);
      navigate("/login", { replace: true });
    }
  }, [status, error, navigate, location, toast]);

  if (status !== "authenticated") return null;
  return <>{children}</>;
}
